<template>
  <div class="LKReportsRoadmapCommon">
    <template v-for="(roadmap) in roadmaps">
      <BLayoutExpansion
        :key="roadmap.id"
        :title="`${roadmap.id} ${roadmap.name}`"
        style="margin-bottom: 16px;"
      >
        <LKReportsRoadmapBasicStatisticsTable
          :list="roadmap.rows"
          :skeleton="skeleton"
        />
      </BLayoutExpansion>
    </template>
  </div>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import LKReportsRoadmapBasicStatisticsTable from './LKReportsRoadmapBasicStatistics/LKReportsRoadmapBasicStatisticsTable.vue'


const BATCH_COUNT = 20
const BATCH_TIMEOUT = 200

export default {
  name: 'LKReportsRoadmapBasicStatistics',
  components: {
    BLayoutExpansion,
    LKReportsRoadmapBasicStatisticsTable,
  },
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    batchCount: 0,
  }),
  computed: {
    roadmaps() {
      return this.data.roadmaps?.slice(0, this.batchCount)
    },
  },
  mounted() {
    this.$nextTick(this.updateBatch)
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    updateBatch() {
      this.timerId = setTimeout(() => {
        this.batchCount += BATCH_COUNT
        if (this.batchCount < this.data.roadmaps?.length) {
          this.$nextTick(this.updateBatch)
        }
      }, BATCH_TIMEOUT)
    },
  },
}
</script>
